module.exports = __webpack_public_path__ + "static/media/entree.4a3c5be4.jpg";